import Vue from "vue";
import "../../theme/index.css";
import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css'
// import "../../theme/display.css";

Vue.use(ElementUI);
